import React, { useState } from 'react';
import { AsyncPaginate } from 'react-select-async-paginate';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import useApiClient from '../../../hooks/api/useApiClient';
import usePermissions, { ManagerRole } from '../../../hooks/auth/usePermissions';
import useTheme from '../../../hooks/context/useTheme';

export default function BusinessProfileSelect({
  value,
  except = [],
  onChange,
  id = undefined,
  isMulti = false,
  className,
}) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Components:Form:Business:BusinessProfileSelect' });

  const { BusinessProfilesManager } = useApiClient();
  const { hasAnyRole } = usePermissions();
  const theme = useTheme();

  const [, setSearch] = useState('');

  const loadData = async (search, loadedOptions, { page }) => {
    let hasMore = false;

    const options = await BusinessProfilesManager.get({
      display_name: search,
      except,
      page,
    }).then((response) => {
      const { data } = response;

      hasMore = data.current_page < data.last_page;

      return data.data;
    });

    return {
      options,
      hasMore,
      additional: {
        page: page + 1,
      },
    };
  };

  return (
    <AsyncPaginate
      id={id}
      className={classnames('cursor-pointer border-none', className)}
      loadOptions={loadData}
      onChange={(item) => onChange(item)}
      onInputChange={setSearch}
      debounceTimeout={500}
      isClearable={hasAnyRole([
        ManagerRole.Admin,
        ManagerRole.SalesManager,
        ManagerRole.SalesLeadership,
        ManagerRole.OnboardingManager,
      ])}
      value={value}
      getOptionValue={(option) => option}
      getOptionLabel={(option) => option.display_name}
      isMulti={isMulti}
      menuPosition="fixed"
      placeholder={t('placeholder')}
      styles={{
        option: (styles, { isDisabled, isFocused, isSelected }) => ({
          ...styles,

          backgroundColor: isSelected ? '#f0fff3' : isFocused ? theme.color.brand.inkGrey.grey_6 : undefined,
          color: isSelected ? theme.color.brand.primary : theme.color.text.default,
          cursor: isDisabled ? 'not-allowed' : 'pointer',

          ':active': isSelected || isFocused ? theme.color.brand.primary : undefined,
        }),
        control: (styles) => ({
          ...styles,
          borderRadius: theme.dimension.borderRadius.mini,
          fontSize: '0.875rem',
        }),
        menu: (styles) => ({
          ...styles,
          borderRadius: theme.dimension.borderRadius.mini,
          fontSize: '0.875rem',
        }),
      }}
      additional={{
        page: 1,
      }}
      defaultAdditional={{
        page: 2,
      }}
    />
  );
}
